import request from '@/plugin/axios'

export function getStatisticalList(data) {
    return request({
        url: '/api/admin/queryLaunchAdvertStatisticsData',
        method: 'get',
        params: data
    })
}